(function() {
    'use strict';

    angular
        .module('askApp')
        .controller('SkipperLevelHolderController', SkipperLevelHolderController);

    SkipperLevelHolderController.$inject = ['SkipperLevelHolder', 'SkipperLevelHolderSearch'];

    function SkipperLevelHolderController(SkipperLevelHolder, SkipperLevelHolderSearch) {

        var vm = this;

        vm.skipperLevelHolders = [];
        vm.clear = clear;
        vm.search = search;
        vm.loadAll = loadAll;

        loadAll();

        function loadAll() {
            SkipperLevelHolder.query(function(result) {
                vm.skipperLevelHolders = result;
                vm.searchQuery = null;
            });
        }

        function search() {
            if (!vm.searchQuery) {
                return vm.loadAll();
            }
            SkipperLevelHolderSearch.query({query: vm.searchQuery}, function(result) {
                vm.skipperLevelHolders = result;
                vm.currentSearch = vm.searchQuery;
            });
        }

        function clear() {
            vm.searchQuery = null;
            loadAll();
        }    }
})();
